module.exports = __webpack_public_path__ + "img/bxc.233ee4f3.png";